export default function BannerTopLoader() {
  return (
    <div className="mt-4 relative animate-pulse  ">
      {" "}
      <div className="max-h-48 h-24 w-full bg-gray-200"></div>
    </div>
  );
}
